
<template>
  <div>
    <div class="disFlex between curse-search">
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-select v-model="formInline.parentid" placeholder="全部试卷类别" clearable>
              <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text"
                style="width: 100%;">
                <el-option v-for="item in group.children" :key="item.uniqueCode" :label="item.text"
                  :value="item.uniqueCode">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-loading="loading" style="padding: 10px;background-color: #fff;">
      <el-table :data="tableData.rows" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
        <el-table-column prop="papersname" fixed width="450" label="试卷名称">
        </el-table-column>
        <el-table-column prop="createTime" label="考试时间" sortable>
        </el-table-column>

        <el-table-column prop="itypename" label="试卷类型" sortable>
        </el-table-column>
        <el-table-column prop="fraction" label="分数" sortable>
        </el-table-column>
        <el-table-column prop="state" fixed="right" width="120" label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看" placement="top">
              <el-button size="mini" circle type="success" icon="el-icon-view"
                @click="toDetail(scope.row.id,1)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;text-align: right;" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 30, 50]"
        :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['creator', 'wjSrc','currentUser'],
    data() {
      return {
        formInline: {
          // parentid: '',
          page: 1,
          rows: 10,
          creator:''
        },
        tableData: {
          rows: [],
          total: 0
        },
        circleUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        options: [{
            text: '专业职称',
            uniqueCode: 'ZXKT_producttype_2',
            children: []
          },
          {
            text: '专业技能',
            uniqueCode: 'ZXKT_producttype_3',
            children: []
          }
        ],
        dialogVisible: false,
        selectUserIds: [],
        selectIdArr: [],
        selectRows: [],
        bmparams: {},
        loading: true
      }
    },
    methods: {
      getcurseList: function() {
        this.loading = true;
        this.$axios.get('/kt/ktQuestionsUser/getlistPage.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '0') {
            this.$message.error(data.message);
          } else {
            this.tableData = data;
          }
          this.loading = false;
        })
      },
      toDetail: function(id) {
        sessionStorage.setItem('myanswerId',id)
        this.$router.push('/Ckjx');
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      showBm: function(id, name, itype, cid, isUser) {
        isUser = isUser ? isUser : [];
        this.bmparams = {
          productname: name,
          productid: id,
          itype: itype,
          cid: cid,
          isUser: isUser
        };
        var selectUserIds = [];
        isUser.map((item) => {
          selectUserIds.push(item.id);
        });
        this.selectUserIds = selectUserIds;
        this.dialogVisible = true;
      },
      changeBb: function(selectIdArr, selectRows) {
        this.selectIdArr = selectIdArr;
        this.selectRows = selectRows;
      },
      handleAave: function() {
        var isUser = [];
        this.selectRows.map((item, i) => {
          isUser.push({
            appyuserid: item.id,
            appyusername: item.realName,
          })
        });
        this.$set(this.bmparams, 'isUser', JSON.stringify(isUser))
        var $this = this;
        this.$axios.post('/kt/ktProductAppy/allocation.htm', this.$qs.stringify(this.bmparams)).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.$message({
              message: data.message,
              type: 'success',
              onClose: function() {
                $this.getcurseList(1)
              }
            });
          } else {
            this.$message.error(data.message);
          }
          this.dialogVisible = false;
        })
      },
      // 跳转准备考试的界面
      toKaoshi:function(id){
        this.$router.push("/Ready?id="+id);
      },
      delCurse: function(id) {
        var $this=this;
        this.$confirm('您确定要删除该课程吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$axios.post('/kt/ktProductAppy/allocation.htm', this.$qs.stringify({id:id})).then(res => {
          //   var data = res.data;
          //   if (data.stat == '1') {
          //     this.$message({
          //       message: data.message,
          //       type: 'success',
          //       onClose: function() {
          //         $this.getcurseList(1)
          //       }
          //     });
          //   } else {
          //     this.$message.error(data.message);
          //   }
          // })
        }).catch(() => {
        });
      }
    },
    created: function() {
      this.$set(this.formInline, 'creator', this.creator);
      this.options[0].children = JSON.parse(localStorage.getItem('zyzcList'));
      this.options[1].children = JSON.parse(localStorage.getItem('zyjnList'));
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getcurseList(1);
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .curse-search {
    padding: 0px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .curse-search .el-form-item {
    margin-bottom: 0;
  }

  .curseInfoBlock {
    width: 256px;
    height: 256px;
    opacity: 1;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    margin: 0 20px 20px 0;
  }

  .curseevery-title {
    width: 236px;
    height: 40px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
    margin: 8px auto;
  }

  .curseevery-title span {
    width: 34px;
    height: 16px;
    opacity: 1;
    background: linear-gradient(126deg, #ff7254 11%, #ff1515 90%);
    border-radius: 6px 6px 6px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.05);
    color: #fff;
    font-size: 12px;
    display: inline-block;
    line-height: 16px;
    text-align: center;
    margin-right: 2px;
  }

  .curseevery-bot {
    width: 256px;
    height: 43px;
    opacity: 1;
    background: #fbfbfc;
    border-top: 1px solid #efefef;
    align-items: center;
    color: #9a9a9a;
    font-size: 13px;
    cursor: pointer;

  }

  .curseevery-bot img {
    margin-right: 4px;
  }

  .curseevery-top {
    position: relative;
  }

  .curseevery-top.ygq::after {
    content: "";
    content: '';
    display: block;
    width: 46px;
    height: 46px;
    background: url(../../assets/images/ygq.png) no-repeat;
    background-size: 46px 46px;
    position: absolute;
    right: 0;
    top: -1px;
  }

  .delVurse {
    position: absolute;
    width: 100%;
    height: 100%;
    display: none;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    align-items: center;
    justify-content: center;
    transition: all 0.3s linear;
  }

  .delVurse span {
    cursor: pointer;
    font-size: 14px;
    color: #ff1515;
  }

  .curseevery-top:hover .delVurse {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/KaoshiList.vue